<template lang="pug">
  .cooperative
    div(v-for="(item, index) in cooperative" :class="[contentAnimation, `animateDelay-${index}`]")
      img(:src="item")
</template>

<script>
  import Mixin from "../../index.js"
  export default {
    name: "cooperative",
    mixins: [Mixin],
    data() {
      return {
        cooperative: [
          require("./images/阿里云.png"),
          require("./images/腾讯云.png"),
          require('./images/华为云.png'),
          require("./images/CEC中国电子.png"),
          require('./images/海南生态软件园.png'),
          require('./images/牛津（海南）.png'),
          require('./images/四川发展.png'),
          require('./images/微看宝宝.png'),
        ],
      };
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .cooperative {
    padding 0 0 100px 0
    max-width 100%
    HStack(center, flex-start)
    flex-wrap wrap
    margin -32px
    div {
      background-color #f8f8f8
      margin 16px
    }
    @media (min-width 968px) {
      width 968px
    }
    @media (max-width screenWidth) {
      padding 8px
      margin 0px
      div {
        width calc(50% - 16px)
        margin 8px
        box-sizing border-box
        img {
          max-width 100%
        }
      }
    }
  }
</style>
